
const TabButton = ({ active, onClick, children }) => (
    <button
        onClick={onClick}
        className={`px-3 sm:px-6 py-2 sm:py-3 font-medium text-xs sm:text-sm rounded-none border-b-2 transition-colors duration-200 whitespace-nowrap ${active
            ? 'border-custom-green-1 text-white bg-white/10'
            : 'border-transparent text-white/70 hover:text-white hover:border-white/30'
            }`}
    >
        {children}
    </button>
);

export default TabButton;